//
import * as djangioActionCreators from "shared/djangio/action-creators"
import {
    getListsForResource as getListsForResourceActionType,
    addListItem as addListItemObj,
    removeListItem as removeListItemObj,
} from "shared/profiles/listAdder/action-types"
import { sendUserActionPost } from "shared/user-actions/user-actions-action-creators"

/**
 * Gets all the newLists the resource identified by id, dataType belongs to
 * @name renameList
 * @function
 * All params are named params being passed via an obj as the first argument
 * @param {number} - dataType - the qdt of the resource
 * @param {number} - id - id of the item
 */
export const getListsForResource = (args) => {
    const { id, dataType } = args
    return djangioActionCreators.sendAction(DjangIO.app.userdata.models.NewList, getListsForResourceActionType, {
        action: "lists_for_resource",
        method: "get",
        kwargs: { id, data_type: dataType, dehydrate_extra: ["project_name"] },
        payload: { id, dataType },
    })
}
/**
 * Removes an item from a newlist using the remove_from_list action
 * @name removeListItem
 * @function
 * All params are named params being passed via an obj as the first argument
 * @param {obj} - item - used to call the remove action with the right id, also for adding/removing to the store
 * @param {obj} - list - used to call the add action with the right id, also for adding/removing to the store, but for listAdders
 * @param {number} - dataType - the qdt of the item being added, if needed
 * @param {number} = region = the region of thr object being removed
 */
export const removeListItem = (args) => async (dispatch) => {
    const { list, item, dataType, region } = args
    const response = await dispatch(
        djangioActionCreators.sendAction(DjangIO.app.userdata.models.NewList.objects.get(list.id), removeListItemObj, {
            action: "remove_from_list",
            kwargs: { id: item.id },
            method: "patch",
            payload: { list, item, dataType },
        }),
    )

    if (response) {
        sendUserActionPost({
            userActionType: DjangIO.app.useractions.types.UserActionType.remove_from_list,
            quorumDataType: dataType,
            regions: [region],
        })
    }

    return response
}

/**
 * Add an item to a newlist using the add_to_list action
 * @name addListItem
 * @function
 * All params are named params being passed via an obj as the first argument
 * @param {obj} - item - used to call the add action with the right id, also for adding/removing to the store
 * @param {obj} - list - used to call the add action with the right id, also for adding/removing to the store, but for listAdders
 * @param {number} - dataType - the qdt of the item being added, if needed
 * @param {number} - region - the region of the object being added
 */
export const addListItem = (args) => async (dispatch) => {
    const { list, item, dataType, region } = args
    const response = await dispatch(
        djangioActionCreators.sendAction(DjangIO.app.userdata.models.NewList.objects.get(list.id), addListItemObj, {
            action: "add_to_list",
            kwargs: { id: item.id },
            method: "patch",
            payload: { list, item, dataType },
        }),
    )

    if (response) {
        sendUserActionPost({
            userActionType: DjangIO.app.useractions.types.UserActionType.add_to_list,
            quorumDataType: dataType,
            regions: [region],
        })
    }

    return response
}
